import { useEffect } from 'react'
import { isProSelector } from '@chegg-wt/core/state/user/selectors'
import { getCookie, setCookie, Cookies } from '@chegg-wt/core/utils/cookies'
import { openModal } from '@chegg-wt/core/state/modals/actions'
import { DISCOUNT_MODAL } from '@chegg-wt/core/state/modals/constants'
import { useDispatch, useSelector } from 'react-redux'
import usePriceTest from './usePriceTest'

export const useShowDiscountModal = () => {
  const dispatch = useDispatch()
  const {
    pricingExperimentEnabled,
    pricingExperimentReady,
    discountPercentage,
    price,
    basePrice,
  } = usePriceTest()

  const isProUser = useSelector(isProSelector)

  useEffect(() => {
    const discountModalShown = getCookie(Cookies.DiscountModalShown)
    if (pricingExperimentReady && pricingExperimentEnabled) {
      if (!discountModalShown && !isProUser && discountPercentage) {
        dispatch(
          openModal({
            name: DISCOUNT_MODAL,
            data: { price, basePrice, discountPercentage },
          })
        )
        const resetDate = new Date()
        resetDate.setDate(resetDate.getDate() + 3)
        setCookie(Cookies.DiscountModalShown, true, { expires: resetDate })
      }
    }
  }, [pricingExperimentReady, pricingExperimentEnabled, discountPercentage, isProUser])
}
